import { computed, ref } from 'vue';

import { defineStore } from 'pinia';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

const { getHotSearchAPI, getCartInfoAPI } = useAxiosAPI();

const useMiniCartStore = defineStore('miniCart', () => {
  const dataIsLoad = ref(false);
  const totalCount = ref(0); // 所有溫藏商品總數
  const generalCount = ref(0); // 常溫總數量
  const refrigerationCount = ref(0); // 冷藏總數量
  const freezingCount = ref(0); // 冷凍總數量
  const generalSpotGoodsCount = ref(0); // 一般常溫現貨數量
  const refrigerationSpotGoodsCount = ref(0); // 冷藏現貨數量
  const freezingSpotGoodsCount = ref(0); // 冷凍現貨數量
  const generalMarketProducts = ref([]);
  const refrigerationMarketProducts = ref([]);
  const freezingMarketProducts = ref([]);
  const temperaturesData = ref([]);
  const count = ref(0); // 所有商品總數(for 一頁式)
  const hotSearch = ref([]);
  const hotLoad = ref(false);

  const isOnlyOneTemp = computed(() => {
    let hasProductTempCount = 0;
    if (generalCount.value > 0) {
      hasProductTempCount += 1;
    }
    if (refrigerationCount.value > 0) {
      hasProductTempCount += 1;
    }
    if (freezingCount.value > 0) {
      hasProductTempCount += 1;
    }
    return hasProductTempCount === 1;
  });

  function changeCartTotalCount(itemArray) {
    totalCount.value = itemArray.data.Response.TotalCount;
    count.value = itemArray.data.Response.TotalCount;
    temperaturesData.value = itemArray.data.Response.Temperatures;
    // 溫層ID (0: 常溫，1: 冷藏，2: 常溫)
    itemArray.data.Response.Temperatures.forEach((item) => {
      if (item.ID === 0) {
        generalCount.value = item.Count;
        generalMarketProducts.value = item.Markets;
        generalSpotGoodsCount.value = item.InstockCount;
      } else if (item.ID === 1) {
        refrigerationCount.value = item.Count;
        refrigerationMarketProducts.value = item.Markets;
        refrigerationSpotGoodsCount.value = item.InstockCount;
      } else {
        freezingCount.value = item.Count;
        freezingMarketProducts.value = item.Markets;
        freezingSpotGoodsCount.value = item.InstockCount;
      }
    });
    dataIsLoad.value = true;
  }

  function getCartInfo() {
    dataIsLoad.value = false;
    getCartInfoAPI()
      .then((res) => {
        if (res.data.Code === 200) {
          changeCartTotalCount(res);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function getHotSearch() {
    hotLoad.value = false;

    getHotSearchAPI({
      params: {
        period: 'range',
        date: 'last3',
        limit: 10,
      },
    })
      .then((res) => {
        if (res.data.Code === 200) {
          const hotArray = [];
          for (let i = 0; i < res.data.Response.length; i++) {
            hotArray.push(res.data.Response[i]);
          }
          hotSearch.value = hotArray;
          hotLoad.value = true;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  return {
    dataIsLoad,
    totalCount,
    generalCount,
    refrigerationCount,
    freezingCount,
    generalMarketProducts,
    refrigerationMarketProducts,
    freezingMarketProducts,
    temperaturesData,
    count,
    hotSearch,
    hotLoad,
    isOnlyOneTemp,
    changeCartTotalCount,
    getCartInfo,
    getHotSearch,
  };
});

export default useMiniCartStore;
